<template>
  <div>
    <div v-if="currentUser">
      <p v-if="canNotOrderForLive">
        {{ I18n.t("artworks.artwork_auction_finished_or_in_progress") }}
      </p>
      <p v-else-if="canNotOrderForHammer">
        {{ I18n.t("auctions_catalogs.auction_started_cannot_add_order") }}
      </p>
      <div v-else>
        <ReportToBid v-if="isLiveCatalog" :artwork="artwork"/>
        <div v-if="!userWithOrder" class="headings--h3 artwork__subheader">
          {{ I18n.t("orders.order_with_limit") }}
        </div>
        <Errors :message="response" @closeCollapse="showCollapse = false" />
        <OrderDetails v-if="userWithOrder" :artwork="artwork" />
        <div class="row justify-content-between">
          <div class="col-sm-6">
            <b-btn v-b-toggle.collapse
                   class="btn btn__default order__edit-options collapsed mb-2">
              {{ I18n.t('orders.edit') }}
            </b-btn>
          </div>
        </div>
        <b-collapse id="collapse" v-model="showCollapse">
          <b-card>
            <OrderForm @showResponse="response = $event"
                       :order="artwork.currentUserOrder"
                       :artwork="artwork" />
          </b-card>
        </b-collapse>
      </div>
    </div>
    <SalesConditions :artwork="artwork" />
  </div>
</template>

<script>
  import ReportToBid from './report_to_bid';
  import Errors from './errors';
  import OrderDetails from './order_details';
  import OrderForm from './order_form';
  import SalesConditions from './sales_conditions';
  import { LIVE_TYPE, HAMMER_TYPE, CATALOG_IN_PROGRESS } from '../../../../consts';

  export default {
    name: 'ModalForm',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        response: '',
        showCollapse: false,
      };
    },
    components: {
      ReportToBid,
      Errors,
      OrderDetails,
      OrderForm,
      SalesConditions,
    },
    computed: {
      currentUser() {
        return this.artwork.currentUserPresent;
      },
      isLiveCatalog() {
        return this.artwork.auctionsCatalog.auctionType === LIVE_TYPE;
      },
      canNotOrderForHammer() {
        return this.artwork.auctionsCatalog.auctionType === HAMMER_TYPE &&
          this.artwork.auctionsCatalog.state === CATALOG_IN_PROGRESS;
      },
      canNotOrderForLive() {
        return this.artwork.auctionsCatalog.auctionType === LIVE_TYPE &&
          !this.artwork.auctionExistOrPending;
      },
      userWithOrder() {
        return Object.prototype.hasOwnProperty.call(this.artwork, 'currentUserOrder');
      },
    },
    created() {
      if (!this.userWithOrder) {
        this.showCollapse = true;
      }
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/orders/index.vue?e942c466